module.exports = __webpack_public_path__ + "static/img/four_ico01.e5bc58c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/four_ico01.jpg
// module id = LxQH
// module chunks = 1